<template>
    <div style="width:100%;min-height:100vh" v-loading="loading" element-loading-text="请等待..."></div>
</template>

<script>
import requestFrom from "../accounts/component/createdForm";

export default {
  data() {
    return {
      loading: true
    };
  },

  created() {
    let data = this.$route.query.data;
    let action = this.$route.query.action;
    requestFrom(action, JSON.parse(data));
  },
  methods: {}
};
</script>
<style lang="less" scoped>
#pay {
  min-height: 500px;
}
</style>
